import { fetchJson$ } from '@atlassian/jira-fetch';

const getDeletionUrl = (baseUrl: string, issueKey: string) =>
	`${baseUrl}/rest/api/3/issue/${issueKey}?deleteSubtasks=true`;

export const deleteIssue = (baseUrl: string, issueKey: string) => {
	const deleteIssueUrl = getDeletionUrl(baseUrl, issueKey);
	return fetchJson$(deleteIssueUrl, { method: 'DELETE' });
};
